export default "__VITE_ASSET__BrvNvPnz__"